import FamilyRecordsModule from '../components/FamilyRecordsModule'

export default function Calendar(){
 return <FamilyRecordsModule module="events"/>
}
